document.addEventListener('DOMContentLoaded', () => {
  // adjust bg 
  const bg = document.querySelector('.plm-bg');
  const header = document.querySelector('#header-component')
  if(bg) {
    bg.style.top = `${header.offsetHeight}px`;
  }
  // adjust bg 

  // product-list carousel
  const sliders = document.querySelectorAll('.plm-product-list--carousel');
  if (sliders.length) {
    sliders.forEach(slider => {
      new Splide(slider).mount();
    });
  }
  // product-list carousel

  // tab collection
  const tab_collections = document.querySelectorAll('.plm-tab-collection');
  if (tab_collections == null) return;
  tab_collections.forEach(tab_collection => {
    const tabs = tab_collection.querySelectorAll('.plm-tab-collection__tab');
    let active_tab = tab_collection.querySelector('.plm-tab-collection__tab[aria-expanded="true"]');
    let active_content = tab_collection.querySelector('.plm-tab-collection__content[aria-hidden="false"]');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        if (tab != active_tab) {
          active_tab.setAttribute('aria-expanded', false);
          active_content.setAttribute('aria-hidden', true);
          const tab_content = tab_collection.querySelector(`#${tab.getAttribute('aria-controls')}`);
          const isExpanded = tab.getAttribute('aria-expanded') === 'true';
          tab.setAttribute('aria-expanded', !isExpanded);
          tab_content.setAttribute('aria-hidden', isExpanded);
          active_tab = tab;
          active_content = tab_content;
        }
      });
    });
  });
  // tab collection

  // sort option
  const sort_options = document.querySelectorAll('.sorting-filter__option');
  sort_options.forEach(option => {
    const sort_placeholder = document.querySelector('.js-sort-placeholder');
    if(location.search.match(option.getAttribute('id'))) {
      sort_placeholder.textContent = option.textContent;
    }
  });
  // sort option

  // product thumbnail
  const product_thumbnail = document.querySelector('.slideshow-controls__thumbnails');
  if(product_thumbnail != null) {
    let active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
    const product_thumbnail_next = document.querySelector('.thumbnail-control-next');
    const product_thumbnail_previous = document.querySelector('.thumbnail-control-previous');
    function update_previous_next_button() {
      if(active_thumbnail == product_thumbnail.lastElementChild) {
        product_thumbnail_next.setAttribute('disabled', true);
      } else {
        product_thumbnail_next.removeAttribute('disabled');
      }
      if(active_thumbnail == product_thumbnail.firstElementChild) {
        product_thumbnail_previous.setAttribute('disabled', true);
      } else {
        product_thumbnail_previous.removeAttribute('disabled');
      }
      active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
    }
    update_previous_next_button();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          update_previous_next_button();
        });
    });
    const config = {
        attributes: true,
        subtree: true
    };
    observer.observe(product_thumbnail, config);

    product_thumbnail_next.addEventListener('click', () => {
      if(active_thumbnail != product_thumbnail.lastElementChild) {
        active_thumbnail.nextElementSibling.click();
        active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
      }
    });
    product_thumbnail_previous.addEventListener('click', () => {
      if(active_thumbnail != product_thumbnail.firstElementChild) {
        active_thumbnail.previousElementSibling.click();
        active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
      }
    });
  }
  // product thumbnail

  // accordion
  const accordions = document.querySelectorAll('.js-plm-accordion');
  if(accordions.length > 0) {
    accordions.forEach(accordion => {
      function accordion_activate(accordion) {
      const button = accordion.querySelector('.js-plm-accordion-button');
      const content = accordion.querySelector('.js-plm-accordion-content');
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    }
      if(accordion.classList.contains('accordion-active-mobile')) {
        if(window.innerWidth < 750) {
          accordion_activate(accordion);
        } else {
          accordion.querySelector('.plm-accordion-menu').removeAttribute('aria-hidden');
        }
      } else if(accordion.classList.contains('accordion-active-desktop')) {
        if(window.innerWidth >= 750) {
          accordion_activate(accordion);
        }
      } else {
        accordion_activate(accordion);
      }
    });
  }
  // accordion
  // accordion-menu
  // if(window.innerWidth < 750) {
  //   const accordion_menues = document.querySelectorAll('.plm-accordion__menu-item');
  //   if(accordion_menues.length > 0) {
  //     accordion_menues.forEach(item => {
  //       if(item.closest('.plm-accordion-container').classList.contains('accordion-disabled')) {
  //         return;
  //       }
  //       item.addEventListener('click', () => {
  //         const isExpanded = item.getAttribute('aria-expanded') === 'true';
  //         item.setAttribute('aria-expanded', !isExpanded);
  //         item.nextElementSibling.setAttribute('aria-hidden', isExpanded);
  //       });
  //     });
  //   }
  // }
  // accordion-menu
});


// 最近見た商品
class CMRecentlyViewed {
  static initialized = false;
  constructor() {
    if (CMRecentlyViewed.initialized) return;
    CMRecentlyViewed.initialized = true;
    this.stock_limit = 10;
    this.storage_key = 'recently_viewed';
    this.containers = document.querySelectorAll('.cm-recently-viewed__inner');
    this.initRecentlyViewed();
    if (location.pathname.includes('/products/')) {
      this.addProduct(location.pathname.split('/').pop());
    }
  }

  initRecentlyViewed() {
    if (!this.containers.length) return;
    this.containers.forEach(async container => {
      const parent_section = container.closest('.cm-recently-viewed');
      const max_products = parent_section ? parent_section.dataset.maxProducts || 10 : 10;
      const recently_viewed_data = this.getProducts();
      const slide_list = container.querySelector('.splide__list');
      const loading_element = parent_section ? parent_section.querySelector('.cm-recently-viewed__loading') : null;

      // 閲覧履歴がない場合はセクションを非表示
      if (!recently_viewed_data.length) {
        if (parent_section) parent_section.classList.add('is-hidden');
        return;
      }

      // ローディングテキストを表示
      if (loading_element) loading_element.classList.add('is-visible');

      // 表示対象のハンドルを制限
      const target_handles = recently_viewed_data.slice(0, max_products);

      // Promise.allで全商品データを並列取得
      const fetch_results = await Promise.all(
        target_handles.map(async (handle) => {
          try {
            const response = await fetch(`/products/${handle}?view=card`);
            const html_text = await response.text();
            if (!html_text.match('plm-product-card')) return null;
            if (html_text.match('404')) return null;
            return html_text;
          } catch (error) {
            console.warn(`商品データの取得に失敗: ${handle}`, error);
            return null;
          }
        })
      );

      // 取得結果をDOMに追加（順序を維持）
      let has_products = false;
      fetch_results.forEach(html_text => {
        if (!html_text) return;
        const slide_item = document.createElement('li');
        slide_item.className = 'splide__slide resource-list__slide';
        slide_item.innerHTML = html_text;
        slide_list.appendChild(slide_item);
        has_products = true;
      });

      // ローディングテキストを非表示
      if (loading_element) loading_element.classList.remove('is-visible');

      // 商品がない場合はセクションを非表示
      if (!has_products) {
        if (parent_section) parent_section.classList.add('is-hidden');
        return;
      }

      // セクション設定をdata属性から取得
      const per_page_pc = parseInt(parent_section?.dataset?.perPagePc, 10) || 4;
      const per_page_sp = parseInt(parent_section?.dataset?.perPageSp, 10) || 2;
      const gap_hr = parseInt(parent_section?.dataset?.gapHr, 10) || 24;
      const gap_hr_mobile = parseInt(parent_section?.dataset?.gapHrMobile, 10) || 12;
      const auto_width_pc = parent_section?.dataset?.autoWidthPc === 'true';
      const auto_width_sp = parent_section?.dataset?.autoWidthSp === 'true';

      // Splideスライダーを初期化
      const splide_options = {
        type: 'slide',
        gap: gap_hr + 'px',
        pagination: false,
        arrows: true,
        breakpoints: {
          750: {
            gap: gap_hr_mobile + 'px',
          },
        },
      };

      // PC: カスタム幅がある場合はautoWidth、なければperPage
      if (auto_width_pc) {
        splide_options.autoWidth = true;
      } else {
        splide_options.perPage = per_page_pc;
      }

      // SP: カスタム幅がある場合はautoWidth、なければperPage
      if (auto_width_sp) {
        splide_options.breakpoints[750].autoWidth = true;
      } else {
        splide_options.breakpoints[750].perPage = per_page_sp;
      }

      new Splide(container, splide_options).mount();
    });
  }

  addProduct(product_id) {
    let recently_viewed = this.getProducts();
    recently_viewed = recently_viewed.filter((id) => id !== product_id);
    recently_viewed.unshift(product_id);
    recently_viewed = recently_viewed.slice(0, this.stock_limit);
    localStorage.setItem(this.storage_key, JSON.stringify(recently_viewed));
  }

  clearProducts() {
    localStorage.removeItem(this.storage_key);
  }

  getProducts() {
    return JSON.parse(localStorage.getItem(this.storage_key) || '[]');
  }
}
document.addEventListener('DOMContentLoaded', () => {
  new CMRecentlyViewed();
});
// 最近見た商品 ここまで